import SupportIcon from "../Icons/SupportIcon";
import Cart from "../Shared/Cart";
import { Link, useLocation } from "react-router-dom";
import whatsapp from "../../assets/whatsapp.svg";
import messenger from "../../assets/messenger.png";

const FloatingButtons = () => {
    const location = useLocation();

    const cartVisibleRoutes = [
        "/",
        "/about-us",
        "/my-profile",
        "/cart-checkout",
        "/courses",
        "/books"
    ];

    const isDynamicRoute = (route: string) =>
        (route.startsWith("/course/") && location.pathname.startsWith("/course/")) ||
        (route.startsWith("/book/") && location.pathname.startsWith("/book/"));

    const isCartVisible = cartVisibleRoutes.includes(location.pathname) || isDynamicRoute(location.pathname);


    return (
        <>
            <div className="fixed bottom-7 right-7 z-[999999999]">
                <Link to={'/support-center'}
                >
                    <button className="sm:p-4 p-3 bg-white  border-2 shadow-md rounded-full relative"
                    >
                        <SupportIcon className="sm:size-auto size-8" />
                    </button>
                </Link>
            </div>
            {isCartVisible &&
                <>
                    <Cart />
                    <div className="fixed sm:bottom-28 bottom-24 sm:right-11 right-9 z-[999999999]">
                        <Link target="_blank" to={'https://wa.me/+201070191322'}
                        >
                            <img src={whatsapp} alt="" className="size-10" />
                        </Link>
                    </div>
                    <div className="fixed sm:bottom-40 bottom-36 sm:right-11 right-9 z-[999999999]">
                        <Link target="_blank" to={'https://m.me/NileWiseCT'}
                        >
                            <img src={messenger} alt="" className="size-10" />
                        </Link>
                    </div>


                </>
            }
        </>
    )
}

export default FloatingButtons